import React from "react";
import UnauthorizedIcon from "../images/UnauthorizedIcon.svg";
import "./PaymentMode.scss";
import { ButtonCustom } from "../UI/ButtonCustom/ButtonCustom";

function Unauthorized() {
  const handleDoneClick = () => {
    const redirectUrl = "https://google.com";
    if (redirectUrl) {
      window.location.replace(redirectUrl); // This will navigate to the new domain
    }
  };
  return (
    <div className="container">
      <div className="details commonBG">
        <img src={UnauthorizedIcon} alt="UnauthorizedIcon" />
        <h3>Unauthorized Input</h3>

        <ButtonCustom basicBtn label="Done" onClick={handleDoneClick} />
      </div>
    </div>
  );
}

export default Unauthorized;
